module.exports = __webpack_public_path__ + "img/user.ce4eaa06.png";